const testimonials = [
  {
    name: "阿宅同学",
    role: "动画爱好者",
    text: "以前找资源要挨个帖子试链接，现在按格式筛一下就能直接转存，省心太多了。",
  },
  {
    name: "追更常客",
    role: "漫画补档党",
    text: "追更补档很及时，失效的链接隔几天就被修好，打包下载一次收齐特别方便。",
  },
  {
    name: "收藏癖患者",
    role: "音乐 / 剧集收藏",
    text: "秒传码和网盘都能用，转存到自己的网盘长期保存，再也不怕资源蒸发。",
  },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="text-sm font-medium text-accent-600">关于我们</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              让资源获取，简单一点
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              宅宅资源库的初心很简单：把分散在各类帖子里的网盘、直链、磁力、秒传资源集中起来，
              用统一的格式筛选帮你快速定位可用链接，并提供热门资源的打包下载入口。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们坚持逐条校验、定期补档，把「失效链接」对你的困扰降到最低。无论是追新番、
              补漫画、找游戏还是收藏音乐，都能在这里一站搞定。
            </p>
            <ul className="mt-5 space-y-3">
              {[
                "逐条校验，优先展示有效资源",
                "多格式覆盖，网盘 / 直链 / 磁力 / 秒传",
                "追更补档，及时同步失效修复",
                "热门资源提供打包下载，一次收齐",
              ].map((t) => (
                <li key={t} className="flex items-center gap-3 text-sm text-foreground-700">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {t}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">大家的评价</h3>
            <div className="mt-4 grid grid-cols-1 gap-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-lg border border-background-200/80 bg-background-100/50 p-4">
                  <div className="flex items-center gap-1 text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                  <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-background-50">
                      <i className="ri-user-smile-line text-sm"></i>
                    </span>
                    <span className="font-medium text-foreground-700">{t.name}</span>
                    <span>· {t.role}</span>
                  </figcaption>
                </figure>
              ))}
            </div>

            <div className="mt-5 flex flex-col gap-3 rounded-lg border border-primary-200 bg-primary-50 p-4 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-mail-send-line text-lg"></i>
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">联系我们</p>
                  <p className="text-xs text-foreground-600">反馈、补档、合作均可来信</p>
                </div>
              </div>
              <a
                href="mailto:hello@zhai-res.com"
                className="flex h-10 items-center justify-center rounded-md bg-primary-500 px-4 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
              >
                hello@zhai-res.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}